// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { XNGAddProductApiParameter, xngAddProductWithResult } from "@steiner/App/Services/CartService";

type AddToCartParameter = {
    onError?: (error: string) => void;
} & XNGAddProductApiParameter &
    HasOnSuccess<CartLineModel>;

type HandlerType = ApiHandler<AddToCartParameter, CartLineModel>;

const xngSendDataToApi: HandlerType = async props => {
    const result = await xngAddProductWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

replaceInChain(chain, SendDataToApi, xngSendDataToApi);
